export var OrganizationInvitationStatus;
(function (OrganizationInvitationStatus) {
    OrganizationInvitationStatus["PENDING"] = "PENDING";
    OrganizationInvitationStatus["EXPIRED"] = "EXPIRED";
})(OrganizationInvitationStatus || (OrganizationInvitationStatus = {}));
//# sourceMappingURL=organizationInvitationRepresentation.js.map